import { render, staticRenderFns } from "./WebsiteContainer.vue?vue&type=template&id=489834ae&scoped=true"
import script from "./WebsiteContainer.vue?vue&type=script&lang=js"
export * from "./WebsiteContainer.vue?vue&type=script&lang=js"
import style0 from "./WebsiteContainer.vue?vue&type=style&index=0&id=489834ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489834ae",
  null
  
)

export default component.exports